import { render, staticRenderFns } from "./panelFile.vue?vue&type=template&id=2caba588&scoped=true"
import script from "./panelFile.vue?vue&type=script&lang=js"
export * from "./panelFile.vue?vue&type=script&lang=js"
import style0 from "./panelFile.vue?vue&type=style&index=0&id=2caba588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caba588",
  null
  
)

export default component.exports